import { useEffect, useState } from "react";

export default function ScreenDebug() {
  const [info, setInfo] = useState({});
  const [height, setHeight] = useState('150px')

  const collectInfo = () => {
    setInfo({
      screen: `${window.screen.width} x ${window.screen.height}`,
      viewport: `${window.innerWidth} x ${window.innerHeight}`,
      pixelRatio: window.devicePixelRatio,
      userAgent: window.navigator.userAgent
    });
  };



  useEffect(() => {
    collectInfo();
    window.addEventListener("resize", collectInfo);

    return () => window.removeEventListener("resize", collectInfo);
  }, []);

  return (
    <div
    onClick={()=>{
        setHeight( height=='150px' ? '10px' : '150px')
    }}  
      style={{
        position: "fixed",
        top: 10,
        right: 10,
        background: "#111",
        color: "#fff",
        padding: "10px 12px",
        borderRadius: 6,
        fontSize: 12,
        zIndex: 99999,
        fontFamily: "monospace",
        opacity: 0.9,
        height:height,
        cursor:'pointer'
      }}
    >
      <div>screen: {info.screen}</div>
      <div>viewport: {info.viewport}</div>
      <div>pixelRatio: {info.pixelRatio}</div>
      <div style={{ maxWidth: 250, wordBreak: "break-all" }}>
        ua: {info.userAgent}
      </div>
    </div>
  );
}